<div class="overview-stats-page">
  <header class="page-header">
    <h1>Vue d'ensemble</h1>
    <p class="subtitle">Tableau de bord global de votre plateforme</p>
  </header>

  @if (isLoading) {
  <div class="loading">
    <div class="spinner"></div>
    <p>Chargement des statistiques...</p>
  </div>
  } @else if (error) {
  <div class="error-message">
    <p>{{ error }}</p>
    <button type="button" (click)="loadStats()">Réessayer</button>
  </div>
  } @else if (stats) {
  <div class="stats-grid">
    <div class="stat-card">
      <div class="stat-icon users">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
          <circle cx="9" cy="7" r="4" />
          <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
          <path d="M16 3.13a4 4 0 0 1 0 7.75" />
        </svg>
      </div>
      <div class="stat-content">
        <span class="stat-value">{{ stats.totalUsers }}</span>
        <span class="stat-label">Utilisateurs inscrits</span>
      </div>
    </div>

    <div class="stat-card">
      <div class="stat-icon active">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <path d="M22 12h-4l-3 9L9 3l-3 9H2" />
        </svg>
      </div>
      <div class="stat-content">
        <span class="stat-value">{{ stats.activeUsers }}</span>
        <span class="stat-label">Actifs (7 jours)</span>
      </div>
    </div>

    <div class="stat-card">
      <div class="stat-icon premium">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <polygon
            points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"
          />
        </svg>
      </div>
      <div class="stat-content">
        <span class="stat-value">{{ stats.premiumUsers }}</span>
        <span class="stat-label">Premium</span>
      </div>
    </div>

    <div class="stat-card">
      <div class="stat-icon connected">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <circle cx="12" cy="12" r="10" />
          <circle cx="12" cy="12" r="3" />
        </svg>
      </div>
      <div class="stat-content">
        <span class="stat-value">{{ stats.connectedUsers }}</span>
        <span class="stat-label">En ligne</span>
      </div>
    </div>

    <div class="stat-card" [class.alert]="stats.pendingReports > 0">
      <div class="stat-icon reports">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <path
            d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
          />
          <line x1="12" y1="9" x2="12" y2="13" />
          <line x1="12" y1="17" x2="12.01" y2="17" />
        </svg>
      </div>
      <div class="stat-content">
        <span class="stat-value">{{ stats.pendingReports }}</span>
        <span class="stat-label">Signalements non traités</span>
      </div>
    </div>

    <div class="stat-card">
      <div class="stat-icon saloons">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
          <polyline points="9 22 9 12 15 12 15 22" />
        </svg>
      </div>
      <div class="stat-content">
        <span class="stat-value">{{ stats.totalSaloons }}</span>
        <span class="stat-label">Saloons</span>
      </div>
    </div>

    <div class="stat-card">
      <div class="stat-icon match">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <path
            d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"
          />
        </svg>
      </div>
      <div class="stat-content">
        <span class="stat-value">{{ stats.totalMatches }}</span>
        <span class="stat-label">Matchs totaux</span>
      </div>
    </div>

    <div class="stat-card">
      <div class="stat-icon conversations">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
        </svg>
      </div>
      <div class="stat-content">
        <span class="stat-value">{{ stats.totalConversations }}</span>
        <span class="stat-label">Conversations</span>
      </div>
    </div>

    <div class="stat-card">
      <div class="stat-icon messages">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <line x1="22" y1="2" x2="11" y2="13" />
          <polygon points="22 2 15 22 11 13 2 9 22 2" />
        </svg>
      </div>
      <div class="stat-content">
        <span class="stat-value">{{ stats.totalMessages }}</span>
        <span class="stat-label">Messages</span>
      </div>
    </div>

    <div class="stat-card">
      <div class="stat-icon cities">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
          <circle cx="12" cy="10" r="3" />
        </svg>
      </div>
      <div class="stat-content">
        <span class="stat-value">{{ stats.citiesCovered }}</span>
        <span class="stat-label">Villes couvertes</span>
      </div>
    </div>

    <div class="stat-card">
      <div class="stat-icon profiles">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
          <circle cx="8.5" cy="7" r="4" />
          <polyline points="17 11 19 13 23 9" />
        </svg>
      </div>
      <div class="stat-content">
        <span class="stat-value">{{ stats.profilesCompleted }}</span>
        <span class="stat-label">Profils complétés</span>
      </div>
    </div>
  </div>
  }
</div>
